import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import {
  ROUTE_PATHS
} from "../../../common_nextgen/utils/Constants";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";

const useCopaySchedule = (
  onSelect,
  hideModal,
  initialSelectParams,
  intialSelectMode,
  initialLookupType,
  selectParamsData,
  setFalg,
  setScheduleDesc,
  onNavigate
) => {
  const { axios_helper_no_header } = useAxios();

  const location = useLocation();
  const stateVal = location.state || [];

  const [selectMode, setSelectedMode] = useState(intialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const interLinkedLookupRef = useRef(null);
  const [disabledDropdowns, setDisabledDropdowns] = useState({});
   const [isPassedExternalParams, setSetIsPassedExternalParams] = useState(false);

  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    paramsData: initialParamsData = {
      cshCopayScheduleId: selectMode
        ? selectParamsData?.cscCopayScheduleName
        : "",
      hiddenRecordIndicator: "Active",
    },
    interLinkedLookupState: initialInterLinkedLookupState = null,
  } = currentState;
  const baseParamsData = selectMode
    ? { ...selectParamsData, hiddenRecordIndicator: "Active" }
    : initialParamsData;

  const [data, setData] = useState([]); /* Copay Schedule Data */
  const [paramsData, setParamsData] = useState(baseParamsData); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [selectedOption, setSelectedOption] = useState("no");
  const [hideFlag, setHideFlag] = useState(false);
    const [interLinkedLookupState, setInterLinkedLookupState] = useState(initialInterLinkedLookupState);
    const copayScheduleInterlinkedParams = useRef(null);
  const toast = useToast();
  const {
    ADD_COPAY_SCHEDULE,
    EDIT_COPAY_SCHEDULE,
    DISPLAY_COPAY_SCHEDULE,
    COPY_COPAY_SCHEDULE,
    COPAY_SCHEDULE_NOTE,
    COPAY_SCHEDULE_STEPS,
  } = ROUTE_PATHS;

  const screen_title = "Copay Schedule";
  const screenNumber = selectMode ? "RCCSH004" : "RCCSH001";

  const isSafeKey = (k) =>
  typeof k === "string" && /^[a-zA-Z0-9_]+$/.test(k);

  /**
    * Encode all the string type request params.
    *
    * @param {*} newParams
    * @returns encoded request params
    */
    const encodeParams = (rawParams) => {
      if (
        rawParams &&
        typeof rawParams === "object" &&
        Object.keys(rawParams || {}).length
      ) {
        Object.keys(rawParams).forEach((key) => {
          if (isSafeKey(key) && typeof rawParams[key] === "string") {
            rawParams[key] = encodeURIComponent(rawParams[key]);
          }
        });
      }
      return rawParams;
    };

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "CSH Copay Schedule ID",
      name: "cshCopayScheduleId",
      label: "Schedule",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Hidden Record IndicatorValid Values",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];
  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? [
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ]
    : [
        {
          button_label: "Add Copay Schedule",
          button_handeler: () => {
            navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_ADD, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const handleBack = () => {
    if (lookupType === "external" && selectMode) {
      window.parent.postMessage(
        {
          type: "hideModal",
        },
        "*"
      );
    } else {
      hideModal();
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "cshCopayScheduleId";
  const statusKey = "hiddenRecordIndicator";

  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? [
        {
          label: "Note",
          icon: <span className="material-icons">note</span>,
          command: () => {
            if (lookupType === "external") {
              if (interLinkedLookupState) {
                window.sessionStorage.setItem(
                  "interLinkedLookupState",
                  JSON.stringify(interLinkedLookupState)
                );
              }
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "COPAY_SCHEDULE_NOTES",
                schedulesDataKey: "selectedCopaySchedules",
                ...((isPassedExternalParams || copayScheduleInterlinkedParams.current) && {
                  externalParams: {
                    lookupType: "external",
                    viewType: "external",
                    fieldMapping: {
                      default: selectParams,
                    },
                    ...(copayScheduleInterlinkedParams.current || {}),
                    appName: "PATIENT_PAY",
                    pageName: "COPAY_SCHEDULE",
                  },
                }),
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            } else if (lookupType === "local") {
              onNavigate({
                data: { ...rowData },
                target: ROUTE_PATHS.COPAY_SCHEDULE_NOTE,
                navType: "local",
                schedulesDataKey: "selectedCopaySchedules",
              });
            }
          },
        },
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramData = selectParams.reduce((acc, key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                acc[key["source"]] = rowData[key["target"]];
              }
              return acc;
            }, {});
            if (lookupType === "local") {
              onSelect(paramData);
              setScheduleDesc(rowData);
              setFalg(true);
            } else if (lookupType !== "external") {
              onSelect(paramData);
              setFalg(true);
            } else {
              if (interLinkedLookupRef.current) {
                const {
                  params: { routePath },
                } = interLinkedLookupRef.current;
                navigateToPage(ROUTE_PATHS[routePath], [
                  {
                    interLinkedLookup: {
                      ...interLinkedLookupRef.current,
                      isLookupPrepopulated: false,
                      selectedItem: rowData,
                      previousScreen: location.pathname,
                      previousState: [
                        {
                          interLinkedLookupState: {
                            lookupType,
                            selectMode,
                            paramsData: {
                              ...paramsData,
                              cshCopayScheduleId: rowData?.cshCopayScheduleId,
                            },
                            selectParams,
                            disabledDropdowns,
                            interLinkedLookupParams: interLinkedLookupRef?.current,
                            isPassedExternalParams,
                          },
                        },
                      ],
                    },
                  },
                ]);
              } else {
                window.parent.postMessage({ type: "responseData", data: paramData }, "*");
              }
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            if (lookupType === "local") {
              onNavigate({
                data: { ...rowData },
                target: ROUTE_PATHS.COPAY_SCHEDULE_DISPLAY,
                navType: "local",
                schedulesDataKey: "selectedCopaySchedules",
              });
            } else {
              if (interLinkedLookupState) {
                window.sessionStorage.setItem(
                  "interLinkedLookupState",
                  JSON.stringify(interLinkedLookupState)
                );
              }
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "COPAY_SCHEDULE_READ_ONLY",
                schedulesDataKey: "selectedCopaySchedules",
                ...((isPassedExternalParams || copayScheduleInterlinkedParams.current) && {
                  externalParams: {
                    lookupType: "external",
                    viewType: "external",
                    fieldMapping: {
                      default: selectParams,
                    },
                    ...(copayScheduleInterlinkedParams.current || {}),
                    appName: "PATIENT_PAY",
                    pageName: "COPAY_SCHEDULE",
                  },
                }),
              };
              console.log("display message", JSON.stringify(message, null, 2));
              window.parent?.postMessage(message, "*");
            }
          },
        },
        {
          label: "Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            if (lookupType === "local") {
              onNavigate({
                data: { ...rowData },
                target: ROUTE_PATHS.COPAY_SCHEDULE_STEPS,
                navType: "local",
                schedulesDataKey: "selectedSchedules",
              });
            } else {
              if (interLinkedLookupState) {
                window.sessionStorage.setItem(
                  "interLinkedLookupState",
                  JSON.stringify(interLinkedLookupState)
                );
              }
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "COPAY_SCHEDULE_STEPS",
                schedulesDataKey: "selectedCopaySchedules",
                ...((isPassedExternalParams || copayScheduleInterlinkedParams.current) && {
                  externalParams: {
                    lookupType: "external",
                    viewType: "external",
                    fieldMapping: {
                      default: selectParams,
                    },
                    ...(copayScheduleInterlinkedParams.current || {}),
                    appName: "PATIENT_PAY",
                    pageName: "COPAY_SCHEDULE",
                  },
                }),
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            }
          },
        },
      ]
    : [
        {
          label: "Note",
          icon: <span className="material-icons">note</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { cshCopayScheduleId } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(COPAY_SCHEDULE_NOTE, [
              ...previousState,
              {
                ...currentState,
                paramsData: {
                  ...paramsData,
                  cshCopayScheduleId: cshCopayScheduleId,
                },
              },
              {
                selectedCopaySchedules: selectedRows.length ? selectedRows : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { cshCopayScheduleId } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_EDIT, [
              ...previousState,
              {
                ...currentState,
                paramsData: {
                  ...paramsData,
                  cshCopayScheduleId: cshCopayScheduleId,
                },
              },
              {
                selectedCopaySchedules: selectedRows.length ? selectedRows : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Copy",
          icon: <span className="material-icons">content_copy</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { cshCopayScheduleId } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(COPY_COPAY_SCHEDULE, [
              ...previousState,
              {
                ...currentState,
                paramsData: {
                  ...paramsData,
                  cshCopayScheduleId: cshCopayScheduleId,
                },
              },
              {
                selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { cshCopayScheduleId } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(ROUTE_PATHS.COPAY_SCHEDULE_DISPLAY, [
              ...previousState,
              {
                ...currentState,
                paramsData: {
                  ...paramsData,
                  cshCopayScheduleId: cshCopayScheduleId,
                },
              },
              {
                selectedCopaySchedules: selectedRows.length ? selectedRows : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            const selectedSchedulesCount = selectedRows.length;
            const { cshCopayScheduleId } = selectedSchedulesCount
              ? selectedRows[selectedSchedulesCount - 1]
              : rowData;
            navigateToPage(COPAY_SCHEDULE_STEPS, [
              ...previousState,
              {
                ...currentState,
                paramsData: {
                  ...paramsData,
                  cshCopayScheduleId: cshCopayScheduleId,
                },
              },
              {
                previousScreen: location.pathname,
                currentIndex: 0,
                selectedSchedules: selectedRows.length ? selectedRows : [rowData],
              },
            ]);
          },
        },
      ];

  if (rowData["hiddenRecordIndicator"] === "Active" && !selectMode) {
    menuOptions.push({
      label: "Hide",
      icon: <span className="material-icons">visibility_off</span>,
      command: () => {
        openHideConfirmationModal();
      },
    });
  }

  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "cshCopayScheduleId",
    },
    {
      header: "Description",
      field: "cshCopayScheduleDesc",
    },
    {
      header: "Steps",
      field: "stepCount",
    },
    {
      header: "Indicators",
      field: "noteExistenceStatus",
      body: (rowData) => (
        <IndicatorCell rowData={rowData} fields={["noteExistenceStatus"]} tooltipContent={{noteExistenceStatus: "Notes"}} />
      ),
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/cshCopayScheduleHeader`,
        null,
        {
          page: page,
          size: rows,
          ...encodeParams(paramsData),
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, hideFlag, lookupType]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const deleteCopaySchedule = () => {
    if (selectedOption === "yes") {
      const params = { cshCopayScheduleId: rowData[parmKey] };
      axios_helper_no_header(
        "DELETE",
        "api/cshCopayScheduleHeader",
        null,
        encodeParams(params)
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({
      ...paramsData,
      screenNumber: screenNumber,
    });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/cshCopayScheduleHeader/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const hideCopaySchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        cshCopayScheduleId: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/cshCopayScheduleHeader/hideCopaySchedule",
        null,
        encodeParams(params)
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          setHideFlag(!hideFlag);
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error hiding/unhiding the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data: eventData } = event.data;
      if (type === "initData") {
        const externalData = eventData?.data || {};
        setSelectedMode(eventData?.selectMode);
        setLookupType("external");
        setParamsData({
          ...paramsData,
          cshCopayScheduleId:
            externalData?.paramsData?.cshCopayScheduleId || "",
        });
        setSelectParams(externalData?.params);
        setDisabledDropdowns({ hiddenRecordIndicator: true });
        if (externalData?.interLinkedLookup) {
          const {
            paramsData: {
              cscCopayScheduleName,
              cscStepNbr,
              cshCopayScheduleDesc,
            },
            params: { routePath },
          } = externalData.interLinkedLookup;
          if (cscCopayScheduleName) {
            navigateToPage(ROUTE_PATHS[routePath], [
              {
                interLinkedLookup: {
                  ...externalData?.interLinkedLookup,
                  isLookupPrepopulated: true,
                  selectedItem: {
                    cshCopayScheduleId: cscCopayScheduleName,
                    cscStepNbr,
                    cshCopayScheduleDesc,
                  },
                },
              },
            ]);
          } else {
            if (externalData.interLinkedLookup.isCopayStepScreen) {
              const { paramsData: _, ...rest } =
                externalData?.interLinkedLookup;
              const interlinkedLookupParams =
                externalData?.interLinkedLookup?.params?.fieldMapping
                  ?.default || [];
              copayScheduleInterlinkedParams.current = {
                interLinkedLookup: { ...rest },
              };
              setSelectParams(
                interlinkedLookupParams.map((item) =>
                  item.target === "cscCopayScheduleName"
                    ? {
                        ...item,
                        ...{
                          target: "cshCopayScheduleId",
                          paramDataKey: "cshCopayScheduleId",
                          legacy: "cshCopayScheduleId",
                        },
                      }
                    : item
                )
              );
            }
            interLinkedLookupRef.current = externalData.interLinkedLookup;
          }
        }
      }
    };
    window.addEventListener("message", handleMessage);

    const interLinkedLookupStateSession = window.sessionStorage.getItem(
      "interLinkedLookupState"
    );
    if (interLinkedLookupStateSession) {
      setInterLinkedLookupState(JSON.parse(interLinkedLookupStateSession));
      window.sessionStorage.removeItem("interLinkedLookupState");
    }

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (interLinkedLookupState) {
      const {lookupType, paramsData, selectMode, interLinkedLookupParams, selectParams, disabledDropdowns, isPassedExternalParams } = interLinkedLookupState;
      setSelectedMode(selectMode);
      setLookupType(lookupType);
      setParamsData(paramsData);
      setSelectParams(selectParams);
      setDisabledDropdowns(disabledDropdowns);
      interLinkedLookupRef.current = interLinkedLookupParams
      setSetIsPassedExternalParams(isPassedExternalParams);
    }
  }, [interLinkedLookupState]);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    selectMode,
    data,
    parmKey,
    statusKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteCopaySchedule,
    setSelectedOption,
    hideCopaySchedule,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    disabledDropdowns,
  };
};

export default useCopaySchedule;
